import { useEffect, useState } from 'react';
import { Input, Button } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAtom } from 'jotai';
import qs from 'qs';
import { CartLength } from '@/model';
import { PC_CDN_HOST } from '@/const/staticURL';
import useCartLength from '@/hooks/useCartLength';
import WithAuth from '@/common/CKBLayout/modules/WithAuth';
// import ImageSearch from '@/common/icons/ImageSearch';
import FileInputContainer from '@/components/FileInputContainer';
import Category from '../Category';
import HistoryModal from './components/HistoryModal';
import './index.scss';
interface Props {
    onChange?: () => void;
    type?: string;
}

/**
 * 1、直接搜词，每次清空条件
 * 2、点击类目后再词搜，在这个类目下词搜，如果词搜无关键字，则搜全部
 * 3、词搜后点击类目，清空搜索条件和关键字，只搜类目商品
 */
const Search = ({ onChange, type }: Props) => {
    const navigate = useNavigate();
    const [showHistory, setShowHistory] = useState<boolean>(false);
    // 购物车小红点数量
    const [cartLength] = useAtom(CartLength.cartLength);
    // 词搜内容
    const [inputValue, setInputValue] = useState('');
    const [urlParams] = useSearchParams();
    const { setNewCartLengthWithRequest } = useCartLength();
    useEffect(() => {
        if (urlParams.get('keyword')) {
            setInputValue(urlParams.get('keyword') || '');
        }
    }, [urlParams]);
    useEffect(() => {
        setNewCartLengthWithRequest();
    }, [setNewCartLengthWithRequest]);
    // TODO navigate传对象
    const searchClick = () => {
        // 点击类目后再词搜，在这个类目下词搜
        if (urlParams.get('productCategoryFrontendId') && inputValue) {
            navigate({
                pathname: '/goodsList',
                search: qs.stringify({
                    keyword: inputValue,
                    productCategoryFrontendId: urlParams.get(
                        'productCategoryFrontendId'
                    ),
                    cateNameJp: urlParams.get('cateNameJp'),
                    time: new Date().getTime()
                })
            });
        } else {
            navigate(
                inputValue
                    ? `/goodsList?keyword=${inputValue}&time=${new Date().getTime()}`
                    : `/goodsList?time=${new Date().getTime()}`
            );
        }
        onChange && onChange();
    };
    const cartClick = () => {
        navigate(`/cart`);
    };
    const renderCommonSearch = () => {
        return (
            <>
                <div
                    className="search-bg"
                    style={{
                        position: 'fixed'
                    }}
                >
                    <div className="w-[100%]">
                        <div className="search-box">
                            <div>
                                <img
                                    onClick={() => {
                                        navigate(`/home`);
                                    }}
                                    className="search-logo"
                                    src="https://static-s.theckb.com/BusinessMarket/Easy/H5/topLogo.png"
                                    alt="logo"
                                />
                            </div>
                            <div className="search-main">
                                <div className="search-input">
                                    <Input
                                        onPressEnter={searchClick}
                                        value={inputValue}
                                        onChange={(e) => {
                                            setInputValue(e.target.value);
                                        }}
                                        onFocus={() => {
                                            setShowHistory(true);
                                        }}
                                        onBlur={() => {
                                            setTimeout(() => {
                                                setShowHistory(false);
                                            }, 300);
                                        }}
                                        className="hover:opacity-60"
                                        style={{
                                            borderRadius: '20px',
                                            fontSize: '14px',
                                            backgroundColor: '#F7F1EE',
                                            borderColor: '#FF5010',
                                            paddingRight: '50px'
                                        }}
                                        size="large"
                                        placeholder={window._$m.t(
                                            '请输入商品名称'
                                        )}
                                    />
                                    {/* <div className="search-camera">
                                        <ImageSearch />
                                        <FileInputContainer
                                            changeParams={onChange}
                                        />
                                    </div> */}
                                </div>
                                <div className="search-btns">
                                    <Button
                                        size="large"
                                        className="hover:opacity-80"
                                        onClick={searchClick}
                                        style={{
                                            borderRadius: '20px',
                                            marginRight: '25px',
                                            minWidth: '160px',
                                            fontSize: '14px',
                                            color: '#fff',
                                            borderColor: '#FF5010',
                                            background:
                                                'linear-gradient(90deg, #FF7E3E 0%, #FF5010 50%, #FE4B0F 100%)'
                                        }}
                                    >
                                        <img
                                            className="h-[14px] mt-[-3px] mr-[2px] align-middle"
                                            src={
                                                PC_CDN_HOST + 'search-cart.svg'
                                            }
                                            alt=""
                                        />
                                        <span>{window._$m.t('搜索')}</span>
                                    </Button>
                                    <WithAuth>
                                        <Button
                                            onClick={cartClick}
                                            size="large"
                                            className="hover:opacity-80"
                                            style={{
                                                borderRadius: '20px',
                                                minWidth: '160px',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                color: '#FF5010',
                                                borderColor: '#FF5010',
                                                backgroundColor: '#F7F1EE'
                                            }}
                                        >
                                            {cartLength > 0 && (
                                                <div className="search-cart-num">
                                                    {cartLength}
                                                </div>
                                            )}
                                            <img
                                                className="h-[14px] mt-[-3px] mr-[4px] align-middle"
                                                src={
                                                    PC_CDN_HOST +
                                                    'search-search.svg'
                                                }
                                                alt=""
                                            />
                                            <span>
                                                {window._$m.t('购物车')}
                                            </span>
                                        </Button>
                                    </WithAuth>
                                </div>
                            </div>
                            <div className="relative float-right right-0 top-[9px] h-[47px] overflow-hidden">
                                <img
                                    className="w-[110px]"
                                    src={PC_CDN_HOST + 'search_mou.png'}
                                    alt=""
                                />
                            </div>
                            <Category
                                changeParams={() => {
                                    onChange?.();
                                    setInputValue('');
                                }}
                            />
                            <HistoryModal
                                show={showHistory}
                                changeParams={() => onChange?.()}
                            />
                        </div>
                    </div>
                </div>
                <div className="h-[182px]" />
            </>
        );
    };
    const renderGoodsListSearch = () => {
        return (
            <>
                <div className="search-newSearch">
                    <div className="w-[100%]">
                        <div className="search-box search-newSearch-box">
                            <div className="search-main">
                                <div>
                                    <div className="leading-10 text-[18px] color-[#1C2026] font-semibold mr-[6px]">
                                        {window._$m.t('箱包皮具')}
                                    </div>
                                </div>
                                <div className="search-input">
                                    <Input
                                        onPressEnter={searchClick}
                                        value={inputValue}
                                        onChange={(e) => {
                                            setInputValue(e.target.value);
                                        }}
                                        onFocus={() => {
                                            setShowHistory(true);
                                        }}
                                        onBlur={() => {
                                            setTimeout(() => {
                                                setShowHistory(false);
                                            }, 300);
                                        }}
                                        className="hover:opacity-60"
                                        style={{
                                            borderRadius: '20px',
                                            fontSize: '14px',
                                            backgroundColor: '#F7F1EE',
                                            borderColor: '#FF5010'
                                        }}
                                        size="large"
                                        placeholder={window._$m.t(
                                            '请输入商品名称'
                                        )}
                                    />
                                    {/* <div className="search-camera">
                                        <ImageSearch />
                                        <FileInputContainer
                                            changeParams={onChange}
                                        />
                                    </div> */}
                                </div>
                                <div className="search-btns">
                                    <Button
                                        size="large"
                                        className="hover:opacity-80"
                                        onClick={searchClick}
                                        style={{
                                            borderRadius: '20px',
                                            marginRight: '25px',
                                            minWidth: '160px',
                                            fontSize: '14px',
                                            color: '#fff',
                                            borderColor: '#FF5010',
                                            background:
                                                'linear-gradient(90deg, #FF7E3E 0%, #FF5010 50%, #FE4B0F 100%)'
                                        }}
                                    >
                                        <img
                                            className="h-[14px] mt-[-3px] mr-[2px] align-middle"
                                            src={
                                                PC_CDN_HOST + 'search-cart.svg'
                                            }
                                            alt=""
                                        />
                                        <span>{window._$m.t('搜索')}</span>
                                    </Button>
                                    <WithAuth>
                                        <Button
                                            onClick={cartClick}
                                            size="large"
                                            className="hover:opacity-80"
                                            style={{
                                                borderRadius: '20px',
                                                minWidth: '160px',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                color: '#FF5010',
                                                borderColor: '#FF5010',
                                                backgroundColor: '#F7F1EE'
                                            }}
                                        >
                                            {cartLength > 0 && (
                                                <div className="search-cart-num">
                                                    {cartLength}
                                                </div>
                                            )}
                                            <img
                                                className="h-[14px] mt-[-3px] mr-[4px] align-middle"
                                                src={
                                                    PC_CDN_HOST +
                                                    'search-search.svg'
                                                }
                                                alt=""
                                            />
                                            <span>
                                                {window._$m.t('购物车')}
                                            </span>
                                        </Button>
                                    </WithAuth>
                                </div>
                            </div>
                            <HistoryModal
                                show={showHistory}
                                changeParams={() => onChange?.()}
                            />
                        </div>
                    </div>
                </div>
                <div className="h-[88px]" />
            </>
        );
    };
    return (
        <div>
            {type === 'goodsListSearch'
                ? renderGoodsListSearch()
                : renderCommonSearch()}
        </div>
    );
};
export default Search;
